<p-dialog
  [(visible)]="isShowCreateDispute"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '350px' }"
>
  <p-header>
    <span *ngIf="orderId && selectedOrder">New Dispute: Order {{ selectedOrder.name }}</span>
    <span *ngIf="!orderId">New Dispute: Job {{ jobNumber }}</span>
  </p-header>
  <div class="ui-g" style="position: relative">
    <div class="ui-g-12" *ngIf="!orderId">
      <div class="ui-g-4">Order</div>
      <div class="ui-g-8">
        <p-dropdown
          [options]="orders"
          placeholder="Select Order"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedOrder"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">Reason</div>
      <div class="ui-g-8">
        <p-dropdown
          [options]="types"
          placeholder="Select Type"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedType"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-g-4">Details</div>
      <div class="ui-g-8"></div>
    </div>
    <div class="ui-g-12" style="margin-top: 30px">
      <div class="ui-g-12">
        <textarea
          pInputTextarea
          [(ngModel)]="disputeMessage"
          [rows]="3"
          [cols]="35"
          [maxlength]="250"
          style="width: 100%"
        ></textarea>
      </div>
    </div>
    <div class="ui-g-12" style="height: 50px; margin-top: 40px">
      <div class="ui-g-12">
        <button
          type="button"
          pButton
          icon="fa ui-icon-close"
          label="Cancel"
          class="ui-button btn-to-right"
          (click)="close()"
        ></button>
        <button
          type="button"
          pButton
          icon="fa ui-icon-check"
          label="Submit"
          class="ui-button green-btn btn-to-right"
          (click)="submit()"
          [disabled]="
            disputeMessage.trim().length == 0 ||
            jobNumberError ||
            loadUserError ||
            !selectedType ||
            loadTypesError
          "
        ></button>
      </div>
    </div>
    <div
      style="
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background: gray;
        opacity: 0.3;
      "
      *ngIf="isBusySubmit || isBusyLoadJob || isBusyLoadUser"
    >
      <img
        src="assets/images/loader.gif"
        style="margin-left: 45%; margin-top: 10%"
        width="50"
        height="50"
        alt="load"
      />
    </div>
  </div>
</p-dialog>
